<div class="go-back" (click)="closeDialog(responses.BACK)">
  <img src="/assets/images/two-factor/back.svg" alt="Volver">
  <p [innerHTML]="'twoFactorDialog_Data9' | i18n"></p>
</div>
<div class="title" [innerHTML]="'twoFactorDialog_Data6' | i18n"></div>
<div class="buttons-container">
  <button class="btn email-btn" (click)="useEmail()" [innerHTML]="'twoFactorDialog_Data7' | i18n"></button>
  <button class="btn phone-btn" (click)="closeDialog(responses.PHONE)" [innerHTML]="'twoFactorDialog_Data8' | i18n"></button>
</div>
